import React from "react";
import Moment from "react-moment";
import { Table, TableRow, TableCell } from "./Table";
import { formatPrice } from "../utils/helpers";

class ReportView extends React.Component {
  renderCell({ data, type }, idx) {
    switch (type) {
      case "date":
        return (
          <Moment utc format="M/D/YYYY">
            {data}
          </Moment>
        );
      case "currency":
        if (data.toString().includes("$")) return data;
        return formatPrice(data, true);
      default:
        return data;
    }
  }

  renderRow = (row, rowIdx) => {
    const { data: { columns } } = this.props;
    const columnSizing = columns.map(() => "1fr").join(" ");

    return (
      <TableRow key={rowIdx} columns={columnSizing}>
        {row.map((data, colIdx) => {
          const { type } = columns[colIdx];
          return (
            <TableCell key={colIdx}>
              {this.renderCell({ data, type })}
            </TableCell>
          );
        })}
      </TableRow>
    );
  };

  render() {
    const { data: { columns, rows } } = this.props;
    const columnSizing = columns.map(() => "1fr").join(" ");

    return (
      <Table>
        <TableRow header columns={columnSizing}>
          {columns.map((col, idx) => (
            <TableCell key={col.title}>{col.title}</TableCell>
          ))}
        </TableRow>
        {rows.map(this.renderRow)}
      </Table>
    );
  }
}

export default ReportView;



// WEBPACK FOOTER //
// ./src/components/ReportView.js